import { Link, useLocation } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { mergeQueryString } from 'bernie-core';

import { usePropertyListing } from 'src/common/stores/contexts';

import { UitkIcon } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';

import { DisclaimerDialogBulletList } from 'components/common/disclaimer-dialog-bullet-list';

interface DisclaimerProps {
  handleBack?: () => void;
}

const LinkTracked = ClickTracker(Link);

export const BreakfastAndWifiDisclaimer: React.FC<DisclaimerProps> = ({ handleBack }) => {
  const { id, legalDisclaimer } = usePropertyListing();
  const location = useLocation();

  if (!legalDisclaimer) {
    return null;
  }

  const dialogId = `BreakfastAndWifiDisclaimerDialog-${id}`;
  const dialogQuery = mergeQueryString(location.search, { pwaDialog: dialogId });

  return (
    <div className="uitk-grid all-t-padding-two" data-stid="breakfast-wifi-disclaimer">
      {legalDisclaimer.title && (
        <UitkMoreInfoTrigger>
          <LinkTracked
            linkName="Breakfast and Wifi Disclaimer Dialog"
            rfrr=".BreakfastAndWifi.DisclaimerDialog"
            to={{ pathname: location.pathname, search: dialogQuery }}
          >
            <div className="uitk-cell uitk-type-300 pwa-theme--grey-700">
              <span className="breakfast-and-wifi-disclaimer-link-text">{legalDisclaimer.title}</span>
            </div>
            <UitkIcon name="info_outline" className="pwa-theme--grey-700 all-r-padding-half" />
          </LinkTracked>
        </UitkMoreInfoTrigger>
      )}
      {legalDisclaimer.disclaimerContents && (
        <DisclaimerDialogBulletList
          dialogId={dialogId}
          dialogType="pwaDialog"
          disclaimerText={legalDisclaimer.disclaimerContents}
          handleClose={handleBack}
          layerId="breakfast-and-wifi-disclaimer"
          disclaimerTextId="breakfast-and-wifi-disclaimer-dialog-text"
        />
      )}
    </div>
  );
};
BreakfastAndWifiDisclaimer.displayName = 'BreakfastAndWifiDisclaimer';
